import React from 'react';

import './Srcolling.scss';


const Srcolling = () => {
    return (
        <div className='mouse'>
            <div className='overflow'>
                <div className='animate'></div>
            </div>
        </div>
    );
};

export default Srcolling;